//Babel Polyfill
require('babel-polyfill');



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/es2015-polyfills/index.js